export const FINISH_ASSESSMENT_MODAL_LABELS = {
  TITLE: 'Finish Assessment',
  ASSESSMENT_CONCLUSION: 'Assessment conclusion',
  OPEN_ISSUES: 'Open issues',
  IRQ_NOT_COMPLETED: 'IRQ not completed',
  CONTROLS_NOT_VALIDATED: 'Controls are not validated',
  ARTIFACT_EXPIRED: (subcategory: string, date: string) => `${subcategory}: expired on ${date}`,
  ARTIFACT_EXPIRES: (subcategory: string, date: string) => `${subcategory}: expires on ${date}`,
  DUE_DATE_LABEL: 'Re-assessment due date',
  DUE_DATE_HELPER_TEXT:
    'Completing an assessment updates the next due date - unless you keep the current date.',
  DUE_DATE_ERROR: 'Please select a custom due date',
  CALCULATED_NEXT_DUE_DATE: (date: string) => `Calculated next due date: ${date}`,
  NO_DUE_DATE: 'Do not set a due date',
  EXISTING_SCHEDULED_DUE_DATE: (date: string) => `Existing scheduled due date: ${date}`,
  CUSTOM_DUE_DATE: 'Set custom due date',
  CANCEL: 'Cancel',
  ERROR_TITLE: 'Failed to finish assessment',
  ERROR_DESCRIPTION: 'Please try again or contact support.',
} as const
